export class ModuleConfiguration {
  static moduleName = 'security';
}



// WEBPACK FOOTER //
// ./src/app/security/security.module.config.ts